module.exports = __webpack_public_path__ + "img/travel_10.9c15d5c2.svg";